import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { AppSettings } from './../../modules/shared/app.settings';
import { UserCommonService } from './../../modules/shared/services/user-common.service';
import { Subscription } from 'rxjs';
import { UiService } from '../../modules/shared/services/ui.service';
import { StorageService } from './../../modules/shared/services/storage.service';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';
import { SidebarService } from '../../modules/shared/services/sidebar.service';
import { NotificationsService } from './../../modules/shared/services/notifications.service';
import { ErrorBindingService } from 'app/modules/shared/services/error-binding.service';
import { ForgotPasswordComponent } from 'app/modules/shared/components/forgot-password/forgot-password.component';


@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  standalone: false
})
export class SignInComponent implements OnInit {

  @ViewChild(ForgotPasswordComponent) forgotPasswordComponent: ForgotPasswordComponent
  signInResponse: any;
  otpId;
  forgotPopup = false;
  signInWelcomeTextLabel;
  signInDescription;
  readMoreLabel;
  usernamePlaceholder;
  passwordPlaceHolder;
  signInLabel;

  loginErrors = {
    username: '',
    password: {
      hasError: false,
      error: []
    },
    general: {
      hasError: false,
      error: []
    }
  };
  subscription: Subscription;
  isSubmitted = false;
  otpPopup = false;
  setPasswordPopup = false;
  submitted: boolean

  otpEmail;
  otpPhone;
  showPassword: boolean = false;
  signInForm = new UntypedFormGroup({
    username: new UntypedFormControl(),
    password: new UntypedFormControl()
  });
  poweredByLogo = '/assets/images/temp/powered-by-logo-white.png';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private uiService: UiService,
    private signInService: UserCommonService,
    private storageService: StorageService,
    private commonBindingDataService: CommonBindingDataService,
    private sidebarService: SidebarService,
    private notificationService: NotificationsService,
    private errorBindingService: ErrorBindingService
  ) { }

  ngOnInit() {
    // this.poweredByLogo = this.commonBindingDataService.getPoweredByLogoFromMetadata();
    this.signInWelcomeTextLabel = this.commonBindingDataService.getLabel('label_sign_in_welcome_text');
    this.signInDescription = this.commonBindingDataService.getLabel('label_sign_in_description');
    this.readMoreLabel = this.commonBindingDataService.getLabel('label_read_more');
    this.usernamePlaceholder = this.commonBindingDataService.getLabel('Username');
    this.passwordPlaceHolder = this.commonBindingDataService.getLabel('Password');
    this.signInLabel = this.commonBindingDataService.getLabel('signInLabel');
    const apiToken = this.storageService.getItem(AppSettings.TOKEN_KEY);
    if (apiToken !== undefined && apiToken !== null) {

      const user: any = this.storageService.getItem(AppSettings.USER_DETAILS);

      this.signInService.getUserProfile(user.id).subscribe(results => {
        this.storageService.setItem(AppSettings.USER_DETAILS, results);
        AppSettings.USER = results;
        this.notificationService.canFetchNotification = true;
      }, (error) => {
        this.onAPIValidation(error);
      });
    }
    this.signInForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  onAPIValidation(error) {

    if (error.general) {
      this.loginErrors.general.hasError = true;
      this.loginErrors.general.error = error.general;
    } else if (error.password) {
      this.loginErrors.password.hasError = true;
      this.loginErrors.password.error = error.password;
    }
  }



  doSignIn() {
    this.submitted = true;
    if (this.signInForm.valid) {
      const userName = this.signInForm.controls.username.value;
      let signInData = {};
      if (userName.match(AppSettings.EMAIL_PATTERN)) {
        signInData = {
          'email': this.signInForm.controls.username.value,
          'password': this.signInForm.controls.password.value,
          'tenantId': AppSettings.TENANT
        };
      } else {
        signInData = {
          'username': this.signInForm.controls.username.value,
          'password': this.signInForm.controls.password.value,
          'tenantId': AppSettings.TENANT
        };
      }
      this.signInApiCall(signInData);
    } else {
      this.errorBindingService.getFormValidationErrors(this.signInForm);
    }
  }



  signInApiCall(signInData) {
    this.signInService.signIn(JSON.stringify(signInData)).subscribe(signInResult => {
      if (signInResult !== undefined && signInResult.sessionToken !== undefined) {
        this.signInResponse = signInResult;
        this.storageService.setItemInCookies(AppSettings.TOKEN_KEY, signInResult.sessionToken);
        this.storageService.setItem(AppSettings.USER_DETAILS, signInResult.user);
        this.signInService.getUserMetaData();
        this.notificationService.canFetchNotification = true;
        if (signInResult.version) {
            this.storageService.setItem(AppSettings.WEB_VERSION, signInResult.version);
          }
        this.setSessionAndUserDetails(signInResult);
      }
    }, (error) => {
      this.errorBindingService.setMessage({ severity: 'error', summary: 'Rejected', detail: error.general[0].message });
    });
  }

  setSessionAndUserDetails(results) {
    // this.storageService.setItem(AppSettings.TOKEN_KEY, results.sessionToken);
    this.storageService.setItemInCookies(AppSettings.TOKEN_KEY, results.sessionToken);
    this.storageService.setItem(AppSettings.USER_DETAILS, results.user);
    AppSettings.HEADER_AUTHORIZATION_VALUE = results.sessionToken;
    AppSettings.USER = results.user;
    this.getTimeSetting();
  }

  getTimeSetting() {
    this.commonBindingDataService.getTiming().subscribe(timeSets => {
      this.storageService.setItem(AppSettings.TIME_SETTINGS, timeSets);
      this.setRoles();
    },
      (error) => {
        this.onAPIValidation(error);
      });
  }


  moduleWiseRouteAccesses() {
    const groups = {};
    let accesses = this.signInResponse.accessGroup;
    for (let i = 0; i < accesses.length; i++) {
      const accessGroupName = accesses[i].accessGroupName;
      if (!groups[accessGroupName]) {
        groups[accessGroupName] = [];
      }
      groups[accessGroupName].push(accesses[i].accessName);
    }
    accesses = [];
    for (const accessGroupName in groups) {
      if (groups.hasOwnProperty(accessGroupName)) {
        accesses.push({ group: accessGroupName, accessName: groups[accessGroupName] });
      }
    }
    this.storageService.setItem(AppSettings.ACCESS_LIST, accesses);
  }

  makeListOfMenuByRole() {

    let accessGroupNames = [];
    accessGroupNames = this.signInResponse.accessGroup;
    accessGroupNames = this.uniqArray(accessGroupNames);
    this.storageService.setItem(AppSettings.ACCESS_MENU, accessGroupNames);

    // let accessGroupNames = [];
    // for (const access of this.signInResponse.accesses) {
    //   accessGroupNames.push(access.accessGroupName);
    // }
    // accessGroupNames = this.uniqArray(accessGroupNames);
    // this.storageService.setItem(AppSettings.ACCESS_MENU, accessGroupNames);
  }

  uniqArray(arrArg) {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) === pos;
    });
  }

  setRoles() {
    this.makeListOfMenuByRole();
    // this.moduleWiseRouteAccesses();
    // AppSettings.roles.forEach(element => {
    //   if (element.roleCode === this.signInResponse.user.roles[0].roleCode) {
    //     AppSettings.LOGGED_IN_ROLE = this.signInResponse.user.roles[0].roleCode;
    //     this.uiService.profileUpdated();
    //     this.sidebarService.getDispatcherMenu();
    //   }
    // });
    AppSettings.LOGGED_IN_ROLE = this.signInResponse.user.roles[0].roleCode;
    this.uiService.profileUpdated();
    this.sidebarService.getDispatcherMenu();

    if (AppSettings.LOGGED_IN_ROLE === '') {
      this.storageService.removeAll();
      const error = {
        general: [
          {
            message: this.commonBindingDataService.getLabel('label_invalid_role')
          }
        ]
      };
      this.onAPIValidation(JSON.stringify(error));
    }
    this.isSubmitted = false;
  }

  forgotPassword() {
    this.forgotPopup = true;
    this.forgotPasswordComponent.setFocus()
  }

  onPopClose(event) {
    this.forgotPopup = false;
  }

  onOtpPopClose(event) {
    this.otpPopup = false;
  }

  onSetPasswordPopClose(event) {
    this.setPasswordPopup = false;
  }

  onOtpPopSave(event) {
    if (event.general !== undefined) {
      this.errorBindingService.setMessage({ severity: 'error', summary: 'OTP', detail: event.general[0].message });

    } else {
      if (event.otpId) {
        this.otpId = event.otpId;
        this.errorBindingService.setMessage({ severity: 'success', summary: 'OTP Verified', detail: 'OTP matched.' });
        this.setPasswordPopup = true;
      }
    }
    this.forgotPopup = false;
    this.otpPopup = false;
  }

  onPopSave(results) {
    this.otpEmail = results.email;
    this.otpPhone = results.phone;
    this.errorBindingService.setMessage({ severity: 'success', summary: 'Forgot Password.', detail: results.general[0].message });
    this.forgotPopup = false;
    this.otpPopup = true;
  }

  eventHandler(event) {
    console.log('signin form', JSON.stringify(event.value));
    if (event.keyCode === 13) {
      this.doSignIn();
    }
  }
}

